// extracted by mini-css-extract-plugin
export default {"sectionContainer":"liveInteraktiv_sectionContainer__Uo+2C"};